class CartIcon extends HTMLElement {
  setCount(value) {
    this.countElement = this.querySelector('[data-cart-items-count]');
    value > 0
      ? (this.countElement.textContent = value)
      : (this.countElement.textContent = '');
  }
}

customElements.get('cart-icon') || customElements.define('cart-icon', CartIcon);
